'use client';
import { PropsWithChildren } from 'react';

import tokens from '@repo/tokens-studio/themes/light.json';
import { SnackbarProvider } from 'notistack';

import { Snackbar } from './components';
import { GlobalStyles } from './theme/GlobalStyles';
import { IThemeProviderProps, ThemeProvider } from './theme/ThemeProvider';

const INITIAL_THEME: IThemeProviderProps['initial'] = {
  tokens,
  theme: {
    variant: 'BRAND1',
    mode: 'LIGHT',
  },
};

export function UiProvider({ children }: PropsWithChildren) {
  return (
    <ThemeProvider initial={INITIAL_THEME}>
      <SnackbarProvider
        Components={{
          success: Snackbar,
          default: Snackbar,
          error: Snackbar,
          info: Snackbar,
          warning: Snackbar,
        }}
      >
        <GlobalStyles />
        {children}
      </SnackbarProvider>
    </ThemeProvider>
  );
}
